import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export const SagaBlueLike = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#f3f3f3',
      100: '#e6e6e6',
      200: '#dcdcdc',
      300: '#cfcfcf',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#7a7a7a',
      700: '#5f5f5f',
      800: '#444444',
      900: '#2f2f2f'
    },
    surface: {
      0: '#ffffff',
      50: '#f3f3f3',
      100: '#e6e6e6',
      200: '#dcdcdc',
      300: '#cfcfcf',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#7a7a7a',
      700: '#5f5f5f',
      800: '#444444',
      900: '#2f2f2f'
    },

    content: {
      hoverBackground: '#e0e0e0'
    },

    highlight: {
      background: '#e0e0e0',
      color: '#222'
    },
    highlightHover: {
      background: '#dcdcdc',
      color: '#222'
    },

    focusRing: {
      shadow: '0 0 0 0 transparent'
    }
  }
});
